import { useLocalObservable } from 'mobx-react-lite';
import { useEffect } from 'react';

import {
  ICallPermissions,
  PermissionsTypes,
} from '@gem/call/Model/callPermissions/callPermissionsModel.types';
import {
  PERMISSIONS_DEFAULT_TRANSLATIONS,
  PERMISSIONS_TYPES_TRANSLATIONS,
} from '@gem/call/constants';
import { CallChangeDefaultPermissionPopup } from '@gem/call/popups/Permissions/CallChangeDefaultPermissionPopup/CallChangeDefaultPermissionPopup';
import { PopupStore, popupsTasks } from '@gem/popups';

import { ICallPermissionProps } from './CallPermission.types';

interface ICallPermissionPresenter {
  childPopup: PopupStore | null;
  permissions: ICallPermissions | null;
  permissionLabel: string;
  permissionValue: string | null;
  permissionType: PermissionsTypes;
  onPermissionClick(): void;
}

export const useCallPermissionPresenter = (
  props: ICallPermissionProps
): ICallPermissionPresenter => {
  const presenter = useLocalObservable<ICallPermissionPresenter>(() => ({
    childPopup: null,
    permissionType: props.permissionType,

    get permissions(): ICallPermissions | null {
      const callPermissions = props.call.permissions;

      return callPermissions ? callPermissions.defaultPermissions : null;
    },

    get permissionLabel(): string {
      return PERMISSIONS_TYPES_TRANSLATIONS[presenter.permissionType];
    },

    get permissionValue(): string | null {
      if (!presenter.permissions) {
        return null;
      }

      const permissionsValue = presenter.permissions[presenter.permissionType];

      if (!permissionsValue) {
        return null;
      }

      return PERMISSIONS_DEFAULT_TRANSLATIONS[permissionsValue];
    },

    onPermissionClick(): void {
      if (!presenter.permissionValue) {
        return;
      }

      props.popupInstance.hide();

      presenter.childPopup = popupsTasks.openPopup(CallChangeDefaultPermissionPopup, {
        onClose: () => props.onClose(),
        onBack: () => {
          props.popupInstance.show();
        },
        params: {
          permissionType: presenter.permissionType,
          callController: props.callController,
          call: props.call,
        },
      });
    },
  }));

  useEffect(() => {
    presenter.permissionType = props.permissionType;
  }, [props.permissionType]);

  return presenter;
};
